export default __webpack_public_path__ + "static/media/TheCall.9c6dcec0.mp4";